import Swiper, { Navigation } from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';


var swiper = Swiper;
var init = false;

function techSwiper() {
  if (window.innerWidth <= 799) {
    if (!init) {
      init = true;
      swiper = new Swiper(".tech-carousel__container", {
        modules: [Navigation],
        slidesPerView: 1.025,
        spaceBetween: 15,
        centeredSlides: true,
        a11y: true,
        navigation: {
          nextEl: '.swiper-button-next__tech',
          prevEl: '.swiper-button-prev__tech',
        },
        breakpoints: {
          401: {
            spaceBetween: 30,
          },
        },
      });
    }
  } else if (init) {
    swiper.destroy();
    init = false;
  }
}
techSwiper();
window.addEventListener("resize", techSwiper);



/** Custom Video Tracking */
const trackedVideos = [];
const addTrackedVideo = (title, event, options) => {
  const foundIndex = trackedVideos.findIndex((video) => video.title === title);

  let trackedVideoState = {
    title,
    play: false,
    end: false,
    progress: [],
  };
  if (foundIndex !== -1) {
    trackedVideoState = trackedVideos[foundIndex];
  }

  switch (event) {
    case 'play':
      if (!trackedVideoState.play) {
        trackedVideoState.play = true;
        if (window.dataLayer) {
          window.dataLayer.push({
            event: 'custom.vimeoTrack',
            'custom.videoAction': 'play',
            'custom.videoName': title,
          });
        }
      }
      break;

    case 'end':
      if (!trackedVideoState.end) {
        trackedVideoState.end = true;
        if (window.dataLayer) {
          window.dataLayer.push({
            event: 'custom.vimeoTrack',
            'custom.videoAction': 'end',
            'custom.videoName': title,
          });
        }
      }
      break;

    case 'progress':
      if (trackedVideoState.progress.indexOf(options.progress) === -1) {
        trackedVideoState.progress.push(options.progress);
        if (window.dataLayer) {
          window.dataLayer.push({
            event: 'custom.vimeoTrack',
            'custom.videoAction': `${options.progress}%`,
            'custom.videoName': title,
          });
        }
      }
      break;

    default:
      break;
  }

  // Append or replace.
  if (foundIndex !== -1) {
    trackedVideos[foundIndex] = trackedVideoState;
  } else {
    trackedVideos.push(trackedVideoState);
  }
};

const videoIframe = document.querySelectorAll('.video__iframe-wrapper iframe');
videoIframe.forEach((iframe) => {
  const player = new Vimeo.Player(iframe);

  if (player) {
    player.on('play', () => {
      player.getVideoTitle().then(function (title) {
        addTrackedVideo(title, 'play');
      });
    });

    player.on('ended', () => {
      player.getVideoTitle().then(function (title) {
        addTrackedVideo(title, 'end');
      });
    });

    player.on('timeupdate', (e) => {
      const progress = parseInt(e.percent * 100, 10);
      if ([25, 50, 75].indexOf(progress) !== -1) {
        // console.log(progress);
        player.getVideoTitle().then(function (title) {
          addTrackedVideo(title, 'progress', { progress });
        });
      }
    });
  }
})
